/** @jsxImportSource @emotion/react */
import { memo, ReactNode } from "react";

import { Accordion as AccordionComp, AccordionDetails, AccordionSummary, Typography } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";

import { root, expandIcon, header, details } from "./styles";

interface Props {
  title: string;
  content: ReactNode;
  isExpanded?: boolean;
  onChange: (event: any, isExpanded: boolean) => void;
}

const Accordion = ({ title, content, isExpanded = false, onChange }: Props): JSX.Element => (
  <AccordionComp css={root} expanded={isExpanded} onChange={onChange}>
    <AccordionSummary
      expandIcon={<ExpandMore css={expandIcon} />}
      aria-controls={`accordion-${title}-content`}
      id={`accordion-${title}`}
    >
      <Typography css={header}>{title}</Typography>
    </AccordionSummary>
    <AccordionDetails css={details}>{content}</AccordionDetails>
  </AccordionComp>
);

export default memo(Accordion);
